import { Button, IconButton } from '@material-ui/core';
import en from '../../../../lang/en-us';
import { useHistory } from 'react-router';
import { useEffect, useState } from 'react';
import {
    SCHEMES_RESPONSE,
} from '../../../../redux-store/types/portfolio';
import { TableCellParams, TableColumn, TableWithCollapse } from '../../../../lib/DataTable';
import NoFoliosFound from '../../makeNct/NoFoliosFound';
import { useTableWithCollapse } from '../../../../lib/DataTable/customHooks';
import { getSipSummary } from '../../../../redux-store/actions/commercialTransactions';
import { ActionHeader } from '../index';
import { KeyboardArrowRight } from '@material-ui/icons';
import { CommercialRootPath } from '../routeConfig';
import { useDispatch } from 'react-redux';
import { SipSummaryObjectType } from './types';
import { formatAsIndianCurrency } from '../../../../utils/currency';

const { dbCommercial, dashboard } = en;

const _renderSipSummaryData = ({ row }: TableCellParams) => {
    const history = useHistory();
    return (
        <>
            <IconButton
                className=""
                aria-label="expand row"
                size="small"
                onClick={(e) => {
                    e.stopPropagation();
                    history.push(`${CommercialRootPath}/${row.userTrxnNo}/sip`, { data: row });
                }}
            >
                <span>View</span>
                <KeyboardArrowRight />
            </IconButton>
        </>
    );
};

const columns: TableColumn[] = [

    // {
    //     field: 'amcName',
    //     headerName: 'Fund House',
    //     width: 200,
    //     filterBy: true,
    //     filterHeader: 'AMC',
    //     filterKey: 'amcName',
    // },
    { field: 'folio', headerName: 'Folio', width: 100 },
    {
        field: 'schemeNameAndCode',
        headerName: 'Scheme Name',
        valueGetter: ({ row }: any) => `${row.schemeName}`,
        width: 240,
        filterBy: true,
        filterHeader: 'Fund House',
        filterKey: 'amcName',
    },
    {
        headerName: 'Transaction No',
        field: 'userTrxnNo',
        valueGetter: ({ row }: any) => !!row.userTrxnNo ? `${row.userTrxnNo}` : 'NA',
        width: 140,
    },
    {
        field: 'frequency',
        headerName: 'Frequency',
        width: 120,
    },
    {
        field: 'amount',
        headerName: 'Amount',
        width: 120,
        valueGetter: ({ row }) => formatAsIndianCurrency(row?.amount),
    },
    {
        field: 'status',
        headerName: 'Status',
        valueGetter: ({ row }: any) => `${row.sipStatus}`,
        width: 100,
        filterBy: true,
        filterHeader: 'Status',
        filterKey: 'sipStatus',
    },
    {
        field: 'viewMore',
        renderCell: _renderSipSummaryData,
        headerName: '',
        width: 80,
    },

    // {
    //     field: 'sip',
    //     headerName: '',
    //     filterBy: true,
    //     filterHeader: 'SIP Status',
    //     filterKey: 'sipStatus',
    //     width: 0,
    // }
];

const SipPause: React.FunctionComponent = () => {
    const [loading, setLoading] = useState<boolean>(false);
    const [rowData, setRowData] = useState<Array<SipSummaryObjectType>>([]);
    const history = useHistory();
    const dispatch = useDispatch();
    const {
        selectedRows,
        setSelectedRows,
        resetTable,
        resetFilters,
        tableColumns,
        tableRows,
        ...filters
    } = useTableWithCollapse<SCHEMES_RESPONSE[]>({
        initialSelectionModal: [],
        rows: rowData,
        columns,
        loading,
    });

    useEffect(() => {
        async function callApi() {
            try {
                setLoading(true);
                const { body: { data = [] } } = await getSipSummary(dispatch);
                setRowData(data);
            } catch (err: any) {
                alert(err.message);
            } finally {
                setLoading(false);
            }
        }
        callApi();
    }, []);

    const handleSubmit = async () => {
    };

    return (
        <div className="curved-bg">
            <ActionHeader header={dbCommercial.ctLinks.sipPause} />
            <div className="curved-bg-content curved-bg-table-outer">
                <div className="curved-bg-content-table">
                    <>
                        {/* <h5> {dbCommercial.sip.purchaseInfo}</h5> */}
                        {!!loading || tableRows.length ? (
                            <TableWithCollapse
                                rows={tableRows}
                                columns={tableColumns}
                                resetFilters={resetFilters}
                                {...filters}
                                notFoundMessage='No Transactions Found'
                            />
                        ) : (
                            <NoFoliosFound info={'No Transactions Found'} />
                        )}
                    </>
                </div>
                {/* <div className="curved-bg-content-inner-bottom">
                    {!!rowData && (
                        <div className="table-submit">
                            <Button
                                className="customBtn"
                                disabled={!selectedRows.length}
                                onClick={handleSubmit}
                            >
                                {dashboard.ChangeDividend.buttonText}
                            </Button>
                        </div>
                    )}
                </div> */}
            </div>
        </div>
    );
};

export default SipPause;
